module.exports = __webpack_public_path__ + "img/building-25.97bd5c74.svg";